import { render, staticRenderFns } from "./progressloading.vue?vue&type=template&id=6bf2d2e5&"
import script from "./progressloading.vue?vue&type=script&lang=js&"
export * from "./progressloading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports